let logoutUser = null;
let showErrorDialog = null;

export function setLogoutUser(logoutFunction) {
    logoutUser = logoutFunction;
}

export function setShowErrorDialog(showErrorDialogFunction) {
    showErrorDialog = showErrorDialogFunction;
}

export function triggerErrorDialog(error) {
    if (showErrorDialog && error) {
        showErrorDialog(error);
    }
}

export async function callApiWithAuthorization(url, options) {
    const BASE_URL = process.env.REACT_APP_DESIGNER_API_URL;
    const token = localStorage.getItem("accessToken");
    const fetchOptions = options || {};
    if (!fetchOptions.headers) {
        fetchOptions.headers = {};
    }
    fetchOptions.headers.Authorization = `Bearer ${token}`;
    const response = await fetch(`${BASE_URL}` + url, fetchOptions);
    if (response.status === 401) {
        return logoutUser();
    }
    if (response.status === 400) {
        const json = await response.json();
        const error = new Error(json.error);
        error.id = json.requestId;
        showErrorDialog(error);
        throw error;
    }
    return response;
}

export async function callApiWithoutAuthorization(url, options) {
    const BASE_URL = process.env.REACT_APP_DESIGNER_API_URL;
    const response = await fetch(`${BASE_URL}` + url, options);
    return response;
}